var map = {
	"./feature_buy_freespin_cn.png": "4f85",
	"./feature_buy_freespin_en.png": "d554",
	"./feature_buy_freespin_id.png": "6bd1",
	"./feature_buy_freespin_ko.png": "b337",
	"./feature_buy_freespin_ph.png": "eb81",
	"./feature_buy_freespin_th.png": "891c",
	"./feature_buy_freespin_zh.png": "33ad9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec8c";